import { jsx as _jsx } from "react/jsx-runtime";
const variantClasses = {
    display: 'font-bold text-fg-primary leading-[1.15]',
    title: 'font-bold text-fg-primary leading-[1.2]',
    heading: 'font-semibold text-fg-primary leading-[1.3]',
    body: 'font-normal text-fg-primary text-base leading-[1.5]',
    'body-muted': 'font-normal text-fg-muted text-base leading-[1.5]',
    caption: 'font-medium text-fg-muted text-sm leading-[1.4]',
};
/* clamp() font sizes cannot be expressed as static Tailwind classes */
const variantFontSize = {
    display: 'clamp(1.75rem, 3vw, 2.75rem)',
    title: 'clamp(1.375rem, 2.4vw, 2rem)',
    heading: 'clamp(1.125rem, 2vw, 1.375rem)',
    body: '1rem',
    'body-muted': '1rem',
    caption: '0.875rem',
};
export function Typography({ as = 'p', children, variant = 'body', className = '', style, }) {
    const Tag = as;
    return (_jsx(Tag, { className: `${variantClasses[variant]} ${className}`, style: { fontSize: variantFontSize[variant], ...style }, children: children }));
}
export function PageTitle({ children, className = '', style }) {
    return _jsx("h1", { className: `sam-type-page-title text-fg-primary m-0 ${className}`, style: style, children: children });
}
export function SectionHeading({ children, className = '', style }) {
    return _jsx("h2", { className: `sam-type-section-heading text-fg-primary m-0 ${className}`, style: style, children: children });
}
export function CardTitle({ children, className = '', style }) {
    return _jsx("h3", { className: `sam-type-card-title text-fg-primary m-0 ${className}`, style: style, children: children });
}
export function Body({ children, className = '', style }) {
    return _jsx("p", { className: `sam-type-body text-fg-primary m-0 ${className}`, style: style, children: children });
}
export function Secondary({ children, className = '', style }) {
    return _jsx("p", { className: `sam-type-secondary text-fg-muted m-0 ${className}`, style: style, children: children });
}
export function Caption({ children, className = '', style }) {
    return _jsx("span", { className: `sam-type-caption text-fg-muted m-0 ${className}`, style: style, children: children });
}
//# sourceMappingURL=Typography.js.map